export default "__VITE_ASSET__DtYpAlnr__"